<template>
  <div
    class="gutenberg-accordion"
    :class="{ 'two-columns': content.length >= 6 && isFullWidth }"
  >
    <template v-if="content.length >= 6 && isFullWidth">
      <div class="left">
        <gutenberg-accordion-item
          v-for="item in column1"
          :key="item.index"
          :item="item"
        />
      </div>
      <div class="right">
        <gutenberg-accordion-item
          v-for="item in column2"
          :key="item.index"
          :item="item"
        />
      </div>
    </template>
    <template v-else>
      <div class="single-column">
        <gutenberg-accordion-item
          v-for="item in content"
          :key="item.index"
          :item="item"
        />
      </div>
    </template>
  </div>
</template>

<script>
import GutenbergAccordionItem from './GutenbergAccordionItem.vue';

export default {
  components: {
    GutenbergAccordionItem,
  },

  data() {
    const { content } = this.$mountEl.dataset;
    const contentList = content
      ? JSON.parse(content)
      : Array.from(this.$mountElSnapshot.getElementsByClassName('item')).map(
          (item) => {
            return {
              title: item
                .getElementsByClassName('title')[0]
                .getElementsByTagName('h3')[0].innerHTML,
              description:
                item.getElementsByClassName('description')[0].innerHTML,
            };
          }
        );

    return {
      isFullWidth: !document.querySelector(
        '.page-template-page-gutenberg-sidebar'
      ),
      content: contentList,
      column1: [],
      column2: [],
    };
  },

  created() {
    const size = this.content.length;
    if (size >= 6 && this.isFullWidth) {
      if (size % 2) {
        this.column1 = this.content.slice(0, size / 2 + 1);
        this.column2 = this.content.slice(size / 2 + 1);
      } else {
        this.column1 = this.content.slice(0, size / 2);
        this.column2 = this.content.slice(size / 2);
      }
    }
  },
};
</script>
